import axios from "axios";
import { getToken } from "../Utlis/UpdateUsersState";

const registerUser = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/register/`,
      data
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const getUserProfile = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}auth/profile/`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    return e?.response;
  }
};

const editUserProfile = async (values) => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}auth/profile/`,
      values,
      { headers: { Authorization: `Bearer ${getToken()}` } }
    );
    return res;
  } catch (e) {
    return e?.response;
  }
};

const changePasswordAPI = async (values) => {
  console.log(values);
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}auth/change-password/`,
      values,
      { headers: { Authorization: `Bearer ${getToken()}` } }
    );
    return res;
  } catch (e) {
    return e?.response;
  }
};

export { getUserProfile, editUserProfile, changePasswordAPI, registerUser };
